<template>
  <vertical-space :top="marginTop" :bottom="marginBottom" :backgroundColor="bgColor">
    <div class="case-view__no-margin">
      <div class="content" :class="{'inverted': inverted}">
        <div
          class="half text"
          v-observe-visibility="{
			callback: fadeInView,
			intersection: {
				threshold: 0.3
			}
		}"
        >
          <h1 :style="{'color': headingColor}">{{ title }}</h1>
          <p :style="{'color': copyColor}">{{ copy }}</p>
        </div>

        <scroll-speed :speed="1.1">
          <div
            slot-scope="{}"
            class="half image"
            :style="{ 'width': imageWidth ? `${ imageWidth }%` : '' }"
          >
            <div class="image__container">
              <img :src="image" alt="An image with parallax" />
            </div>
          </div>
        </scroll-speed>
      </div>
    </div>
  </vertical-space>
</template>

<script>
import { mapState } from "vuex";
import LazyLoad from "vanilla-lazyload";
import scrollSpeed from "@/components/scroll-speed.vue";
import verticalSpace from "@/components/vertical-space.vue";

export default {
  name: "CaseViewDoubleWithoutMargin",
  components: { scrollSpeed, verticalSpace },
  props: {
    inverted: Boolean,
    headingColor: String,
    copyColor: String,
    bgColor: String,
    title: String,
    copy: String,
    image: String,
    imageWidth: Number,

    marginTop: { type: Number, default: 0 },
    marginBottom: { type: Number, default: 0 },
  },
  methods: {
    fadeInView(isVisible, entry) {
      if (isVisible) {
        Object.assign(entry.target.style, {
          transition: "all 1s cubic-bezier(0.215, 0.61, 0.355, 1)",
          opacity: "1",
          transform: "translateY(0)"
        });
      } else if (entry.boundingClientRect.bottom > window.innerHeight) {
        Object.assign(entry.target.style, {
          opacity: "0",
          transform: "translateY(5em)"
        });
      } else {
        Object.assign(entry.target.style, {
          opacity: "0"
        });
      }
    }
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy"
    });
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.case-view__no-margin {
  max-width: 100%;
  display: flex;
  align-items: center;

  box-sizing: border-box;

  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    height: 100%;
    width: 100%;

    .half {
      box-sizing: border-box;

      &.text {
        width: 100%;
        padding: $margin2-1 $margin1-4 $margin1-2;
        z-index: 1;
        @media screen and (min-width: 440px) {
          padding: $margin1-1 $margin1-2;
        }
        @media screen and (min-width: 550px) {
          padding: 0 $margin1-2;
          width: 45%;
        }
        @media screen and (min-width: 769px) {
          padding: 0 0 0 $margin1-1;
        }
        @media screen and (min-width: 1025px) {
          padding: 0 0 0 $margin2-1;
        }
        @media screen and (min-width: 1880px) {
          padding: 0 0 0 $margin3-1;
        }

        h1 {
          font-size: $font-size-m;
          font-family: $font-expanded;
          line-height: 1;
          margin-bottom: 0.5em;
          max-width: 10em;
          @media screen and (min-width: 1025px) {
            font-size: $font-size-ml;
          }
          @media screen and (min-width: 1550px) {
            font-size: $font-size-l;
          }
        }

        p {
          width: 100%;
          max-width: 30em;
          line-height: $larger-line-height;
          font-size: $font-size-xs;
          white-space: pre-wrap;
          @media screen and (min-width: 769px) {
            font-size: $font-size-s;
          }
          @media screen and (min-width: 2000px) {
            font-size: 1.2em;
          }
        }
      }

      &.image {
        display: flex;
        align-items: center;
        width: 100%;
        padding: $margin1-2 0;
        min-height: auto;
        margin: 0 auto;

        @media screen and (min-width: 550px) {
          width: 55%;
          min-height: 50vh;
        }

        .image__container {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 100%;
          min-height: 100px;
          z-index: 1;

          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }

    &.inverted {
      flex-direction: row-reverse;

      .half.text {
        padding: $margin1-1 $margin1-4;
        text-align: right;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 100%;
        @media screen and (min-width: 440px) {
          padding: $margin1-1 $margin1-2;
        }
        @media screen and (min-width: 550px) {
          padding: 0 $margin1-2;
          width: 45%;
        }
        @media screen and (min-width: 769px) {
          padding: 0 $margin1-1 0 0;
        }
        @media screen and (min-width: 1025px) {
          padding: 0 $margin2-1 0 0;
        }
        @media screen and (min-width: 1880px) {
          padding: 0 $margin3-1 0 0;
        }
      }
    }
  }
}
</style>
